import { PLAYER_METRIC_TOOLTIPS } from './tooltips';
import { RanksType } from '../atoms/Ranks';
import ProjectedPAIScore from '../types/ProjectedPAIScore';

export type PaiConfidenceCoefficient = 'High' | 'Good' | 'Medium' | 'Low';
export type ScoreTooltipMetric = RanksType | 'mph';

export function getPPAIConfidenceCoefficient(value: number): PaiConfidenceCoefficient {
  if (value < 1.5) {
    return 'High';
  }

  if (value < 2.0) {
    return 'Good';
  }

  if (value < 2.5) {
    return 'Medium';
  }

  return 'Low';
}

export function getPPAIConfidenceWidth(score?: ProjectedPAIScore): number | undefined {
  const { upperBound, lowerBound } = score || {};

  if (typeof upperBound !== 'number'
    || typeof lowerBound !== 'number'
    || !Number.isFinite(upperBound)
    || !Number.isFinite(lowerBound)
    || upperBound < lowerBound) {
    return undefined;
  }

  return upperBound - lowerBound;
}

export function getScoreTooltip(metric: ScoreTooltipMetric, value: number, options? : {
  isHSMPH?: boolean,
  year?: number,
  confidenceCoefficient?: number
}): string {
    if (value == null) {
        return '';
    }
    switch (metric) {
        case RanksType.PAI:
        return `${value.toFixed(2)} ${PLAYER_METRIC_TOOLTIPS.PAI}`;
        case RanksType.PROJECTED_PAI:
          const confidenceCoefficient = options?.confidenceCoefficient;
          const confidenceLabel = (typeof confidenceCoefficient === 'number'
            && Number.isFinite(confidenceCoefficient)
            && confidenceCoefficient >= 0)
            ? `- Confidence: ${getPPAIConfidenceCoefficient(confidenceCoefficient)}`
            : '';
          return `${value.toFixed(1)} ${PLAYER_METRIC_TOOLTIPS.PPAI}${confidenceLabel}`;
        case RanksType.COMBINE:
        return `${value.toFixed(2)} ${PLAYER_METRIC_TOOLTIPS.HS_COMBINE}`;
        case 'mph':
            if (!options?.isHSMPH) {
                return `${value.toFixed(2)} ${PLAYER_METRIC_TOOLTIPS.COLLEGE_MPH}`;
            } else {
                return `${value.toFixed(2)} ${PLAYER_METRIC_TOOLTIPS.HS_MPH}`;
            }
        case RanksType.PPI:
          const yearText = options?.year ? ` for ${options.year}` : ' Most Recent';
        return `${value.toFixed(2)} ${PLAYER_METRIC_TOOLTIPS.PPI}${yearText}`;
        case RanksType.PRO_COMBINE:
        return `${value.toFixed(2)} ${PLAYER_METRIC_TOOLTIPS.PRO_COMBINE}`;
        default:
        return '';
    }
}
